// libs
import React from 'react';

// components
import { Box } from '@lyearn/ui';

// types
import { TouchableProps } from './types';

const Touchable: React.FC<React.PropsWithChildren<TouchableProps>> = React.forwardRef(
  (props, ref) => {
    const { className, onPress, children, ...restProps } = props;

    return (
      <Box
        // @ts-ignore
        ref={ref}
        className={className}
        role="button"
        tabIndex={0}
        onClick={onPress}
        {...restProps}>
        {children}
      </Box>
    );
  },
);

export default Touchable;
